import { render, staticRenderFns } from "./kioskSwitch.vue?vue&type=template&id=8446538e&lang=true&"
import script from "./kioskSwitch.vue?vue&type=script&lang=js&"
export * from "./kioskSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports